import "./App.scss";
import React, { Suspense, useEffect, useState } from "react";
import { FirstLoad } from "components";
import { Routes, Route } from "react-router-dom";
import { Home } from "pages";
import AboutDetail from "container/About/AboutDetail";

function App() {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  useEffect(() => {
    const firstLoadTimeOut = setTimeout(() => {
      setIsFirstLoad(false);
    }, 5000);
    return () => {
      clearTimeout(firstLoadTimeOut);
    };
  }, []);

  return (
    <div className="app">
      <Suspense fallback={<FirstLoad />}>
        <Routes>
          <Route exact path="/about-detail" element={<AboutDetail />} />
          <Route
            exact
            path="/"
            element={isFirstLoad ? <FirstLoad /> : <Home />}
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
